// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/company_intake.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { InherentRiskTemplate, IRQAnswer } from "./company_service_pb";
import { file_inventory_v1_company_service } from "./company_service_pb";
import type { CustomFieldEdgeType } from "./custom_field_service_pb";
import { file_inventory_v1_custom_field_service } from "./custom_field_service_pb";
import type { TemplateBuilderCondition } from "./template_builder_lib_pb";
import { file_inventory_v1_template_builder_lib } from "./template_builder_lib_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/company_intake.proto.
 */
export const file_inventory_v1_company_intake: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_inventory_v1_company_service, file_inventory_v1_custom_field_service, file_inventory_v1_template_builder_lib]);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueSingleSelect
 */
export type IntakeQuestionAnswerValueSingleSelect = Message<"inventory.v1.IntakeQuestionAnswerValueSingleSelect"> & {
  /**
   * @generated from field: string value_id = 1;
   */
  valueId: string;
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueSingleSelect.
 * Use `create(IntakeQuestionAnswerValueSingleSelectSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueSingleSelectSchema: GenMessage<IntakeQuestionAnswerValueSingleSelect> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 0);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueMultiSelect
 */
export type IntakeQuestionAnswerValueMultiSelect = Message<"inventory.v1.IntakeQuestionAnswerValueMultiSelect"> & {
  /**
   * @generated from field: repeated string value_ids = 1;
   */
  valueIds: string[];
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueMultiSelect.
 * Use `create(IntakeQuestionAnswerValueMultiSelectSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueMultiSelectSchema: GenMessage<IntakeQuestionAnswerValueMultiSelect> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 1);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueFreeText
 */
export type IntakeQuestionAnswerValueFreeText = Message<"inventory.v1.IntakeQuestionAnswerValueFreeText"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueFreeText.
 * Use `create(IntakeQuestionAnswerValueFreeTextSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueFreeTextSchema: GenMessage<IntakeQuestionAnswerValueFreeText> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 2);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueDate
 */
export type IntakeQuestionAnswerValueDate = Message<"inventory.v1.IntakeQuestionAnswerValueDate"> & {
  /**
   * @generated from field: google.protobuf.Timestamp value = 1;
   */
  value?: Timestamp;
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueDate.
 * Use `create(IntakeQuestionAnswerValueDateSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueDateSchema: GenMessage<IntakeQuestionAnswerValueDate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 3);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueContact
 */
export type IntakeQuestionAnswerValueContact = Message<"inventory.v1.IntakeQuestionAnswerValueContact"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueContact.
 * Use `create(IntakeQuestionAnswerValueContactSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueContactSchema: GenMessage<IntakeQuestionAnswerValueContact> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 4);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValueCompanyAutocomplete
 */
export type IntakeQuestionAnswerValueCompanyAutocomplete = Message<"inventory.v1.IntakeQuestionAnswerValueCompanyAutocomplete"> & {
  /**
   * @generated from field: string company_pdl_id = 1;
   */
  companyPdlId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValueCompanyAutocomplete.
 * Use `create(IntakeQuestionAnswerValueCompanyAutocompleteSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueCompanyAutocompleteSchema: GenMessage<IntakeQuestionAnswerValueCompanyAutocomplete> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 5);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeQuestionAnswerValue
 */
export type IntakeQuestionAnswerValue = Message<"inventory.v1.IntakeQuestionAnswerValue"> & {
  /**
   * @generated from oneof inventory.v1.IntakeQuestionAnswerValue.value
   */
  value: {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueSingleSelect single_select_value = 1;
     */
    value: IntakeQuestionAnswerValueSingleSelect;
    case: "singleSelectValue";
  } | {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueMultiSelect multi_select_value = 2;
     */
    value: IntakeQuestionAnswerValueMultiSelect;
    case: "multiSelectValue";
  } | {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueFreeText free_text_value = 3;
     */
    value: IntakeQuestionAnswerValueFreeText;
    case: "freeTextValue";
  } | {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueDate date_value = 4;
     */
    value: IntakeQuestionAnswerValueDate;
    case: "dateValue";
  } | {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueContact contact_value = 5;
     */
    value: IntakeQuestionAnswerValueContact;
    case: "contactValue";
  } | {
    /**
     * @generated from field: inventory.v1.IntakeQuestionAnswerValueCompanyAutocomplete company_autocomplete_value = 6;
     */
    value: IntakeQuestionAnswerValueCompanyAutocomplete;
    case: "companyAutocompleteValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.IntakeQuestionAnswerValue.
 * Use `create(IntakeQuestionAnswerValueSchema)` to create a new message.
 */
export const IntakeQuestionAnswerValueSchema: GenMessage<IntakeQuestionAnswerValue> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 6);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * Creates a company and records the intake form answers in one atomic operation.
 *
 * @generated from message inventory.v1.SubmitIntakeFormRequest
 */
export type SubmitIntakeFormRequest = Message<"inventory.v1.SubmitIntakeFormRequest"> & {
  /**
   * @generated from field: string request_title = 1;
   */
  requestTitle: string;

  /**
   * The intake template the user answered
   *
   * @generated from field: inventory.v1.IntakeTemplate template = 3;
   */
  template?: IntakeTemplate;

  /**
   * Answers keyed by question id.
   *
   * @generated from field: map<string, inventory.v1.IntakeQuestionAnswerValue> question_id_to_answer = 4;
   */
  questionIdToAnswer: { [key: string]: IntakeQuestionAnswerValue };

  /**
   * Inherent risk questionnaire answers.
   *
   * @generated from field: repeated inventory.v1.IRQAnswer irq_answers = 5;
   */
  irqAnswers: IRQAnswer[];

  /**
   * Snapshot of the IRQ template at submission time. Stored so reviewers see
   * the original questions/options regardless of later template edits.
   *
   * @generated from field: inventory.v1.InherentRiskTemplate inherent_risk_template = 6;
   */
  inherentRiskTemplate?: InherentRiskTemplate;
};

/**
 * Describes the message inventory.v1.SubmitIntakeFormRequest.
 * Use `create(SubmitIntakeFormRequestSchema)` to create a new message.
 */
export const SubmitIntakeFormRequestSchema: GenMessage<SubmitIntakeFormRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 7);

/**
 * @generated from message inventory.v1.SubmitIntakeFormResponse
 */
export type SubmitIntakeFormResponse = Message<"inventory.v1.SubmitIntakeFormResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;
};

/**
 * Describes the message inventory.v1.SubmitIntakeFormResponse.
 * Use `create(SubmitIntakeFormResponseSchema)` to create a new message.
 */
export const SubmitIntakeFormResponseSchema: GenMessage<SubmitIntakeFormResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 8);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeTemplateOption
 */
export type IntakeTemplateOption = Message<"inventory.v1.IntakeTemplateOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message inventory.v1.IntakeTemplateOption.
 * Use `create(IntakeTemplateOptionSchema)` to create a new message.
 */
export const IntakeTemplateOptionSchema: GenMessage<IntakeTemplateOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 9);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * A single question in the intake template.
 *
 * @generated from message inventory.v1.IntakeTemplateQuestion
 */
export type IntakeTemplateQuestion = Message<"inventory.v1.IntakeTemplateQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.IntakeQuestionType type = 2;
   */
  type: IntakeQuestionType;

  /**
   * @generated from field: string question = 3;
   */
  question: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: repeated inventory.v1.IntakeTemplateOption options = 5;
   */
  options: IntakeTemplateOption[];

  /**
   * @generated from field: optional inventory.v1.TemplateBuilderCondition condition = 6;
   */
  condition?: TemplateBuilderCondition;

  /**
   * The only allowed edge type for custom field
   *
   * @generated from field: optional inventory.v1.CustomFieldEdgeType custom_field_allowed_type = 7;
   */
  customFieldAllowedType?: CustomFieldEdgeType;

  /**
   * If set, responses to this question are synced to the mapped custom field on submission.
   *
   * @generated from field: optional string custom_field_id = 8;
   */
  customFieldId?: string;

  /**
   * Whether an answer is required before the intake can be submitted.
   *
   * @generated from field: bool required = 9;
   */
  required: boolean;

  /**
   * Whether the question is a system question (that can't be changed)
   *
   * @generated from field: bool system_question = 10;
   */
  systemQuestion: boolean;

  /**
   * The target request field we map a question answer to
   *
   * @generated from field: inventory.v1.RequestField target_request_field = 11;
   */
  targetRequestField: RequestField;

  /**
   * @generated from field: bool hidden = 12;
   */
  hidden: boolean;
};

/**
 * Describes the message inventory.v1.IntakeTemplateQuestion.
 * Use `create(IntakeTemplateQuestionSchema)` to create a new message.
 */
export const IntakeTemplateQuestionSchema: GenMessage<IntakeTemplateQuestion> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 10);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * A section (group) of questions in the intake template.
 *
 * @generated from message inventory.v1.IntakeTemplateSection
 */
export type IntakeTemplateSection = Message<"inventory.v1.IntakeTemplateSection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated inventory.v1.IntakeTemplateQuestion questions = 4;
   */
  questions: IntakeTemplateQuestion[];

  /**
   * @generated from field: string how_data_is_used_markdown = 5;
   */
  howDataIsUsedMarkdown: string;
};

/**
 * Describes the message inventory.v1.IntakeTemplateSection.
 * Use `create(IntakeTemplateSectionSchema)` to create a new message.
 */
export const IntakeTemplateSectionSchema: GenMessage<IntakeTemplateSection> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 11);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * Customizable properties of IRQ questions in Intake form
 *
 * @generated from message inventory.v1.IntakeIRQuestionProperties
 */
export type IntakeIRQuestionProperties = Message<"inventory.v1.IntakeIRQuestionProperties"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: bool hidden = 2;
   */
  hidden: boolean;

  /**
   * @generated from field: bool required = 3;
   */
  required: boolean;
};

/**
 * Describes the message inventory.v1.IntakeIRQuestionProperties.
 * Use `create(IntakeIRQuestionPropertiesSchema)` to create a new message.
 */
export const IntakeIRQuestionPropertiesSchema: GenMessage<IntakeIRQuestionProperties> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 12);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeTemplate
 */
export type IntakeTemplate = Message<"inventory.v1.IntakeTemplate"> & {
  /**
   * @generated from field: repeated inventory.v1.IntakeTemplateSection sections = 1;
   */
  sections: IntakeTemplateSection[];

  /**
   * @generated from field: inventory.v1.IntakeTemplateIRQSection irq_section = 2;
   */
  irqSection?: IntakeTemplateIRQSection;
};

/**
 * Describes the message inventory.v1.IntakeTemplate.
 * Use `create(IntakeTemplateSchema)` to create a new message.
 */
export const IntakeTemplateSchema: GenMessage<IntakeTemplate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 13);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IntakeTemplateIRQSection
 */
export type IntakeTemplateIRQSection = Message<"inventory.v1.IntakeTemplateIRQSection"> & {
  /**
   * @generated from field: repeated inventory.v1.IntakeIRQuestionProperties irq_question_properties = 1;
   */
  irqQuestionProperties: IntakeIRQuestionProperties[];

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message inventory.v1.IntakeTemplateIRQSection.
 * Use `create(IntakeTemplateIRQSectionSchema)` to create a new message.
 */
export const IntakeTemplateIRQSectionSchema: GenMessage<IntakeTemplateIRQSection> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 14);

/**
 * @generated from message inventory.v1.GetIntakeTemplateRequest
 */
export type GetIntakeTemplateRequest = Message<"inventory.v1.GetIntakeTemplateRequest"> & {
};

/**
 * Describes the message inventory.v1.GetIntakeTemplateRequest.
 * Use `create(GetIntakeTemplateRequestSchema)` to create a new message.
 */
export const GetIntakeTemplateRequestSchema: GenMessage<GetIntakeTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 15);

/**
 * @generated from message inventory.v1.GetIntakeTemplateResponse
 */
export type GetIntakeTemplateResponse = Message<"inventory.v1.GetIntakeTemplateResponse"> & {
  /**
   * @generated from field: inventory.v1.IntakeTemplate template = 1;
   */
  template?: IntakeTemplate;
};

/**
 * Describes the message inventory.v1.GetIntakeTemplateResponse.
 * Use `create(GetIntakeTemplateResponseSchema)` to create a new message.
 */
export const GetIntakeTemplateResponseSchema: GenMessage<GetIntakeTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 16);

/**
 * Full state replacement: the request contains the complete desired template state.
 * - Objects present in the request but missing from the current template are created (id should be given).
 * - Objects present in the current template but missing from this request are deleted.
 * - Objects with a matching id but different fields are updated.
 *
 * @generated from message inventory.v1.UpdateIntakeTemplateRequest
 */
export type UpdateIntakeTemplateRequest = Message<"inventory.v1.UpdateIntakeTemplateRequest"> & {
  /**
   * @generated from field: inventory.v1.IntakeTemplate template = 1;
   */
  template?: IntakeTemplate;
};

/**
 * Describes the message inventory.v1.UpdateIntakeTemplateRequest.
 * Use `create(UpdateIntakeTemplateRequestSchema)` to create a new message.
 */
export const UpdateIntakeTemplateRequestSchema: GenMessage<UpdateIntakeTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 17);

/**
 * @generated from message inventory.v1.UpdateIntakeTemplateResponse
 */
export type UpdateIntakeTemplateResponse = Message<"inventory.v1.UpdateIntakeTemplateResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateIntakeTemplateResponse.
 * Use `create(UpdateIntakeTemplateResponseSchema)` to create a new message.
 */
export const UpdateIntakeTemplateResponseSchema: GenMessage<UpdateIntakeTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_intake, 18);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from enum inventory.v1.IntakeQuestionType
 */
export enum IntakeQuestionType {
  /**
   * @generated from enum value: INTAKE_QUESTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTAKE_QUESTION_TYPE_SINGLE_SELECT = 1;
   */
  SINGLE_SELECT = 1,

  /**
   * @generated from enum value: INTAKE_QUESTION_TYPE_MULTI_SELECT = 2;
   */
  MULTI_SELECT = 2,

  /**
   * @generated from enum value: INTAKE_QUESTION_TYPE_FREE_TEXT = 3;
   */
  FREE_TEXT = 3,

  /**
   * Company name autocomplete powered by PDL search.
   *
   * @generated from enum value: INTAKE_QUESTION_TYPE_COMPANY_AUTOCOMPLETE = 4;
   */
  COMPANY_AUTOCOMPLETE = 4,

  /**
   * A contact field capturing name + email.
   *
   * @generated from enum value: INTAKE_QUESTION_TYPE_CONTACT = 5;
   */
  CONTACT = 5,

  /**
   * @generated from enum value: INTAKE_QUESTION_TYPE_DATE = 6;
   */
  DATE = 6,
}

/**
 * Describes the enum inventory.v1.IntakeQuestionType.
 */
export const IntakeQuestionTypeSchema: GenEnum<IntakeQuestionType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_intake, 0);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * Possible fields in third party request. Use REQUEST_FIELD_NONE for questions
 * that don't map to any structured request field. REQUEST_FIELD_UNSPECIFIED is
 * reserved as a zero/error sentinel and should never be persisted.
 *
 * @generated from enum inventory.v1.RequestField
 */
export enum RequestField {
  /**
   * @generated from enum value: REQUEST_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Company name autocomplete powered by PDL search.
   *
   * @generated from enum value: REQUEST_FIELD_COMPANY_AUTOCOMPLETE = 1;
   */
  COMPANY_AUTOCOMPLETE = 1,

  /**
   * @generated from enum value: REQUEST_FIELD_ENGAGEMENT_TYPE = 2;
   */
  ENGAGEMENT_TYPE = 2,

  /**
   * @generated from enum value: REQUEST_FIELD_ENGAGEMENT_NAME = 3;
   */
  ENGAGEMENT_NAME = 3,

  /**
   * @generated from enum value: REQUEST_FIELD_ENGAGEMENT_DESCRIPTION = 4;
   */
  ENGAGEMENT_DESCRIPTION = 4,

  /**
   * @generated from enum value: REQUEST_FIELD_BUSINESS_OWNER = 5;
   */
  BUSINESS_OWNER = 5,

  /**
   * @generated from enum value: REQUEST_FIELD_POINT_OF_CONTACT = 6;
   */
  POINT_OF_CONTACT = 6,

  /**
   * The question does not map to a structured request field.
   *
   * @generated from enum value: REQUEST_FIELD_NONE = 7;
   */
  NONE = 7,
}

/**
 * Describes the enum inventory.v1.RequestField.
 */
export const RequestFieldSchema: GenEnum<RequestField> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_intake, 1);

/**
 * @generated from service inventory.v1.CompanyIntakeService
 */
export const CompanyIntakeService: GenService<{
  /**
   * @generated from rpc inventory.v1.CompanyIntakeService.GetIntakeTemplate
   */
  getIntakeTemplate: {
    methodKind: "unary";
    input: typeof GetIntakeTemplateRequestSchema;
    output: typeof GetIntakeTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyIntakeService.UpdateIntakeTemplate
   */
  updateIntakeTemplate: {
    methodKind: "unary";
    input: typeof UpdateIntakeTemplateRequestSchema;
    output: typeof UpdateIntakeTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyIntakeService.SubmitIntakeForm
   */
  submitIntakeForm: {
    methodKind: "unary";
    input: typeof SubmitIntakeFormRequestSchema;
    output: typeof SubmitIntakeFormResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_company_intake, 0);

